//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { localStorageIsSupported } from '~~/utils'

export default {
  name: 'AppBrowserDetection',

  data() {
    return {
      show: false
    }
  },

  mounted() {
    const hideBanner =
      localStorageIsSupported() && localStorage.getItem('hideLegacyBanner')

    if (this.$device.isLegacy && !hideBanner) {
      this.show = true
    }
  },

  methods: {
    hide() {
      localStorage.setItem('hideLegacyBanner', true)

      this.show = false
    }
  }
}
